import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setCustomer,
  setPbxId,
  setReactCustomer,
  setTenantId,
} from "./customerSlice";

const clearCustomer = createAsyncThunk(
  "customer/clearCustomer",
  (_, { dispatch }) => {
    dispatch(setCustomer(null));
    dispatch(setReactCustomer(null));
    dispatch(setTenantId(null));
    dispatch(setPbxId(null));
  }
);

export default clearCustomer;
